import React from 'react';
import './CancelledScreen.css';
import checkIcon from '../assets/close.svg';



const CancelledScreen= ({business_info, customer_info}) => {
  	// return (
    // 		<div className="iphone-14-15-pro-6">
    //   			<img className="waitwhiz-logo-pure-white-backg-icon" alt="" src="https://i.ibb.co/Nr7qRgH/Waitwhiz-Logo-Pure-White-Background.png" />
    //   			<img className="brand-logo" alt="" src={business_info.business_metadata.logo_url} />
    //   			<div className="iphone-14-15-pro-6-child" />
    //   			<b className="hi-user-text">Hi {customer_info.customer_name},</b>
    //   			<b className="you-have-been">You have been removed from queue</b>
    //   			<b className="please-visit-reception">Please visit reception if still wish to dine with us</b>
    //   			<img className="close-icon" alt="" src={checkIcon} />
    //   			{/* <b className="call-comorin">Call Comorin</b> */}
    // 		</div>);

	const backgroundImage = customer_info.business_id === 75
    ? 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url("https://i.ibb.co/k2vKnB51/8-F4-A9424-1.jpg")'
    : customer_info.business_id === 88
    ? 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url("https://i.ibb.co/chWqyYJV/Cafe-C-Interface-Waitwhiz-ai.jpg")'
    : 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url("https://i.ibb.co/nMdYspGB/waitwhiz-background-image.jpg")';


return (
	<div className="screen-root" style={{background: backgroundImage, color: '#fff'}}>
	<div className="frame-parent">
	<div className="waitwhiz-logo-pure-white-backg-parent-waiting">
          <img className="brand-logo" alt="" src={business_info.business_metadata.logo_url} />
    </div>
	<div className="frame-group">
	<div className="hi-user">
	<b className="hi-user-text">Hi {customer_info.customer_name},</b>
	<b className="hi-user-text">You have been removed from the queue at {business_info.business_name}!</b>
	</div>
	<div className="ellipse-parent" style={{backgroundColor: 'transparent'}}>
	<div className="frame-child" style={{backgroundColor: '#f54749'}}></div>
	<img className="check-icon" alt="" src={checkIcon} />
	</div>
	<div className="for-menu-click-here-parent">
            <div className="hi-user-text">
              <a
                className="click-here"
                href={business_info.business_metadata.menu_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: 8, display: 'inline-block', verticalAlign: 'middle' }}
              >
                Tap Here
              </a>
              <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                <p>to See Our Menu</p>
              </span>
            </div>
          </div>
	</div>
	<div className="for-menu-click-here-parent">
            <p className="hi-user-text">
              If you still wish to dine with us, please visit reception.
              <br />

            </p>
			{business_info.business_metadata.contact_info && (
						<a 
						className="call-comorin" style={{color: '#377dff'}}
						href={`tel:${business_info.business_metadata.contact_info}`}
				>
						Call {business_info.business_name}
						</a>)}
          </div>
	</div>
	</div>);

};

export default CancelledScreen;
